import React from 'react'
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import RebalancingOrder from '../RebalancingOrder/Index'

function RebalancingOrderLayout() {
  return (
    <>
     <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
          }}
        >
           <Container maxWidth="xxl" sx={{ mt: 12, mb: 2 }}>
           <RebalancingOrder/>
          </Container>
        </Box>
    </>
  )
}

export default RebalancingOrderLayout
